<template>
  <div>
    <b-modal
      id="modal-edit-koordinator"
      size="xl"
      centered
      title="Edit Data Koordinator"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Nama Koordinator" label-cols-md="3">
          <b-form-input
            autofocus
            type="text"
            :state="checkIfValid('namaKoordinator')"
            v-model="$v.dataEdit.namaKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Kode Koordinator" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('kodeKoordinator')"
            v-model="$v.dataEdit.kodeKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="$store.state.role_aktif.kodeRole == 'super'" label="Nama Mitra" label-cols-md="3">
          <multiselect
            v-model="$v.dataEdit.mitraIdEdit.$model"
            :state="checkIfValid('mitraIdEdit')"
            :options="mitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Provinsi" label-cols-md="3">
          <multiselect
            v-model="$v.dataEdit.provinsiIdEdit.$model"
            :state="checkIfValid('provinsiIdEdit')"
            :options="provinsi"
            @input="getKotas(dataEdit.provinsiIdEdit)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaProvinsi"
            track-by="id"
            placeholder="-- Pilih Provinsi --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kota" label-cols-md="3">
          <multiselect
            v-model="$v.dataEdit.kotaIdEdit.$model"
            :state="checkIfValid('kotaIdEdit')"
            :options="kota"
            @input="getKecamatans(dataEdit.kotaIdEdit)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKota"
            track-by="idKota"
            placeholder="-- Pilih Kabupaten/Kota --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kecamatan" label-cols-md="3">
          <multiselect
            v-model="$v.dataEdit.kecamatanIdEdit.$model"
            :state="checkIfValid('kecamatanIdEdit')"
            :options="kec"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKecamatan"
            track-by="kecamatanId"
            placeholder="-- Pilih Kecamatan --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Alamat" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('alamatKoordinator')"
            v-model="$v.dataEdit.alamatKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="No. Telp" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('noHpKantor')"
            v-model="$v.dataEdit.noHpKantor.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Latitude" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('latitude')"
            v-model="$v.dataEdit.latitude.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Longtitude" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('longitude')"
            v-model="$v.dataEdit.longitude.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit-koordinator')"
        >
          Tutup
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  components: { Multiselect },
  props: ["data", "mitra", "provinsi", "edit"],
  data() {
    return {
      dataEdit: {
        mitraIdEdit: "",
        provinsiIdEdit: "",
        kotaIdEdit: "",
        kecamatanIdEdit: "",
        namaKoordinator: "",
        kodeKoordinator: "",
        alamatKoordinator: "",
        noHpKantor: "",
        longitude: "",
        latitude: "",
      },
      kota: [],
      kec: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataEdit, null, 4);
    },
    isValid() {
      return !this.$v.dataEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataEdit.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataEdit: {
      mitraIdEdit: {
        required,
      },
      provinsiIdEdit: {
        required,
      },
      kotaIdEdit: {
        required,
      },
      kecamatanIdEdit: {
        required,
      },
      namaKoordinator: {
        required,
      },
      kodeKoordinator: {
        required,
      },
      alamatKoordinator: {
        required,
      },
      noHpKantor: {
        required,
      },
      longitude: {
        required,
      },
      latitude: {
        required,
      },
    },
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        for (let i = 0; i < this.provinsi.length; i++) {
          if (this.provinsi[i].id == this.data.provinsiId) {
            this.dataEdit.provinsiIdEdit = this.provinsi[i];
          }
        }
        for (let i = 0; i < this.provinsi.length; i++) {
          if (this.provinsi[i].id == this.data.provinsiId) {
            this.dataEdit.provinsiIdEdit = this.provinsi[i];
          }
        }
        for (let i = 0; i < this.mitra.length; i++) {
          if (this.mitra[i].id == this.data.mitraId) {
            this.dataEdit.mitraIdEdit = this.mitra[i];
          }
        }
        this.dataEdit.namaPusat = this.data.namaPusat;
        this.dataEdit.namaKoordinator = this.data.namaKoordinator;
        this.dataEdit.kodeKoordinator = this.data.kodeKoordinator;
        this.dataEdit.alamatKoordinator = this.data.alamatKoordinator;
        this.dataEdit.noHpKantor = this.data.noHpKantor;
        this.dataEdit.longitude = this.data.longitude;
        this.dataEdit.latitude = this.data.latitude;
        this.getKota(this.dataEdit.provinsiIdEdit);
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataEdit[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async getKota(x) {
      let kota = await this.$axios.get("kota/listByProvinsiId/" + x.id);
      // console.log(kota.data.data, "ini kota");
      this.kota = kota.data.data;
      for (let i = 0; i < this.kota.length; i++) {
        if (this.kota[i].idKota == this.data.kotaId) {
          this.dataEdit.kotaIdEdit = this.kota[i];
        }
      }
      // console.log(this.data.kotaIdEdit, "kota edit");
      this.getKecamatan(this.dataEdit.kotaIdEdit);
    },
    async getKotas(x) {
      let kota = await this.$axios.get("kota/listByProvinsiId/" + x.id);
      // console.log(kota.data.data, "ini kota");
      this.kota = kota.data.data;
      this.dataEdit.kotaIdEdit = "";
      this.dataEdit.kecamatanIdEdit = "";
    },
    async getKecamatan(x) {
      // console.log(x);
      let kec = await this.$axios.get("kecamatan/listByKotaId/" + x.idKota
      );
      // console.log(kec.data.data, "ini kecamatan");
      this.kec = kec.data.data;
      for (let i = 0; i < this.kec.length; i++) {
        this.kec[i].id = this.kec[i].kecamatanId
        if (this.kec[i].kecamatanId == this.data.kecamatanId) {
          this.dataEdit.kecamatanIdEdit = this.kec[i];
        }
      }
    },
    async getKecamatans(x) {
      let kec = await this.$axios.get("kecamatan/listByKotaId/" + x.idKota
      );
      // console.log(kec.data.data, "ini kecamatan");
      this.kec = kec.data.data.map(x=>{
        return{
          ...x,
          id: x.kecamatanId,
        }
      });
      this.dataEdit.kecamatanIdEdit = "";
    },
    simpan() {
      let vm = this;
      vm.data.provinsiId = vm.dataEdit.provinsiIdEdit.id;
      vm.data.mitraId = vm.dataEdit.mitraIdEdit.id; 
      vm.data.kotaId = vm.dataEdit.kotaIdEdit.idKota;
      vm.data.kecamatanId = vm.dataEdit.kecamatanIdEdit.kecamatanId;
      vm.data.id = vm.data.koordinatorId;
      vm.data.namaKoordinator = vm.dataEdit.namaKoordinator;
      vm.data.kodeKoordinator = vm.dataEdit.kodeKoordinator;
      vm.data.alamatKoordinator = vm.dataEdit.alamatKoordinator;
      vm.data.noHpKantor = vm.dataEdit.noHpKantor;
      vm.data.longitude = vm.dataEdit.longitude;
      vm.data.latitude = vm.dataEdit.latitude;
      vm.$axios
        .post("koordinator/update", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH DATA KOORDINATOR",
              showing: true,
            });
            this.$bvModal.hide("modal-edit-koordinator");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: _.toUpper(res.data.message),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
